var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6123 11.0612H19.0545V20.3333C19.0545 21.0396 19.6271 21.6122 20.3334 21.6122H29.6055V19.0544H21.6123V11.0612Z",
    fill: "#E34949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3334 4.66663C11.681 4.66663 4.66675 11.6808 4.66675 20.3333C4.66675 28.9858 11.681 36 20.3334 36C28.9859 36 36.0001 28.9858 36.0001 20.3333C36.0001 11.6808 28.9859 4.66663 20.3334 4.66663ZM7.22457 20.3333C7.22457 13.0935 13.0936 7.22445 20.3334 7.22445C27.5732 7.22445 33.4423 13.0935 33.4423 20.3333C33.4423 27.5731 27.5732 33.4421 20.3334 33.4421C13.0936 33.4421 7.22457 27.5731 7.22457 20.3333Z",
    fill: "#E34949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3282da698bc7eccaa8acd082c5436d92.svg";
export { ForwardRef as ReactComponent };